import {AbstractControl, FormBuilder, FormGroup} from "@angular/forms";
import {merge, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {ProductCollectionsEnum} from "../../shared/enums/product-collections.enum";
import {DictionaryModel} from "../../shared/models/dictionary.model";
import {HlaCollectionParamsFilterModel} from "../models/search-params/filters/hla-collection-params-filter.model";
import {CollectionSearchParamsFactoryService} from "../services/factories/collection-search-params-factory.service";
import {CollectionFilterBaseForm} from "./collection-filter-base.form";

export class HlaCollectionFilterForm extends CollectionFilterBaseForm<HlaCollectionParamsFilterModel> {
    public collection: ProductCollectionsEnum  = ProductCollectionsEnum.ECACCHLA;

    public get iHWNumber(): AbstractControl {
        return this.formInstance.get("iHWNumber");
    }

    public get serologicalFields(): AbstractControl {
        return this.formInstance.get("serologicalFields");
    }

    public get dnaProbeFields(): AbstractControl {
        return this.formInstance.get("dnaProbeFields");
    }

    public get nonHlaGenesFields(): AbstractControl {
        return this.formInstance.get("nonHlaGenesFields");
    }

    public static createForm(
        formBuilder: FormBuilder, initialValues: HlaCollectionParamsFilterModel,
        searchParamsFactory: CollectionSearchParamsFactoryService
    ): HlaCollectionFilterForm {

        const form = formBuilder.group({
            iHWNumber: [initialValues.iHWNumber],
            serologicalFields: [initialValues.serologicalFields],
            dnaProbeFields: [initialValues.dnaProbeFields],
            nonHlaGenesFields: [initialValues.nonHlaGenesFields]
        });

        return new HlaCollectionFilterForm(form, initialValues, searchParamsFactory);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: HlaCollectionParamsFilterModel,
        searchParamsFactory: CollectionSearchParamsFactoryService
    ) {
        super(formInstance, initialValues, searchParamsFactory);
    }

    protected createChangeSubscription(): Observable<HlaCollectionParamsFilterModel> {
        return merge(
            this.iHWNumber.valueChanges.pipe(
                map((iHWNumber: string) => ({iHWNumber}))
            ),
            this.serologicalFields.valueChanges.pipe(
                map((serologicalFields: DictionaryModel<string>) => ({serologicalFields}))
            ),
            this.dnaProbeFields.valueChanges.pipe(
                map((dnaProbeFields: DictionaryModel<string>) => ({dnaProbeFields}))
            ),
            this.nonHlaGenesFields.valueChanges.pipe(
                map((nonHlaGenesFields: DictionaryModel<string>) => ({nonHlaGenesFields}))
            )
        )
        .pipe(
            map(partialModel => this.getModel(partialModel))
        );
    }
}
